export class Triggers {
  // TODO: Rename triggersExiIntent trigger
  constructor(
    {
      triggersTimeOnPage: timeOnPage,
      triggersTimeOnSite: timeOnSite,
      triggersScrollPosition: scrollPosition,
      triggersExiIntent: exiIntent
    },
    storage
  ) {
    this.triggers = [];
    this.items = [];
    this.allTriggered = false;
    this.storage = storage;
    this.rules = {
      timeOnPage,
      timeOnSite,
      scrollPosition,
      exiIntent
    };

    if (timeOnPage > 0) {
      this.triggers.push({
        type: 'timeOnPage',
        timeOnPage
      });
    }

    if (timeOnSite > 0) {
      this.triggers.push({
        type: 'timeOnSite',
        timeOnSite
      });
    }

    if (scrollPosition > 0) {
      this.triggers.push({
        type: 'scrollPosition',
        scrollPosition
      });
    }

    if (exiIntent) {
      this.triggers.push({
        type: 'exitIntent'
      });
    }

    this.checkScrollPosition = this.checkScrollPosition.bind(this);
  }

  init() {
    let promises = [];

    const { timeOnPage, timeOnSite, scrollPosition, exiIntent } = this.rules;

    if (!this.allTriggered) {
      promises = this.triggers.map(async (item) => {
        await this[item.type](item);
      });
    }

    return new Promise((resolve) => {
      if (timeOnPage > 0 || timeOnSite > 0 || scrollPosition > 0 || exiIntent) {
        Promise.race(promises).then(() => {
          this.allTriggered = true;

          resolve();
        });
      }
    });
  }

  timeOnPage(item) {
    return new Promise((resolve) => {
      this.items.push(item);

      setTimeout(() => {
        resolve();
      }, item[item.type] * 1000);
    });
  }

  timeOnSite(item) {
    const [firstVisitValue, firstVisitOperations] =
      this.storage.firstVisit || [];
    const dateFromStorage = firstVisitValue ? new Date(firstVisitValue) : null;
    const firstVisitTime = new Date();
    let interval;
    let targetTime;

    if (!dateFromStorage) {
      if (firstVisitOperations) {
        firstVisitOperations.set(firstVisitTime);
      }

      targetTime = firstVisitTime.setSeconds(
        firstVisitTime.getSeconds() + item[item.type]
      );
    } else {
      targetTime = dateFromStorage.setSeconds(
        dateFromStorage.getSeconds() + item[item.type]
      );
    }

    return new Promise((resolve) => {
      this.items.push(item);

      interval = setInterval(() => {
        const currentTime = new Date();

        if (currentTime.getTime() > targetTime) {
          clearInterval(interval);
          if (firstVisitOperations) {
            firstVisitOperations.remove();
          }

          resolve();
        }
      }, 1000);
    });
  }

  checkScrollPosition() {
    const supportPageOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
    const scroll = supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
    const scrollPercentage =
      (scroll / (document.documentElement.offsetHeight - window.innerHeight)) *
      100;

    if (scrollPercentage > this.scrollItem[this.scrollItem.type]) {
      this.scrollResolve();
      document.removeEventListener('scroll', this.checkScrollPosition, false);
    }
  }

  scrollPosition(item) {
    return new Promise((resolve) => {
      this.scrollResolve = resolve;
      this.scrollItem = item;
      this.items.push(item);

      this.checkScrollPosition();
      document.addEventListener('scroll', this.checkScrollPosition, false);
    });
  }

  exitIntent() {
    return new Promise((resolve) => {
      document.addEventListener(
        'mouseleave',
        () => {
          const [wasIntentValue, wasIntentOperations] = this.storage
            .wasIntent || [undefined, undefined];

          if (!wasIntentValue && wasIntentOperations) {
            wasIntentOperations.set(true);
            resolve();
          }
        },
        false
      );
    });
  }
}
